module.exports = __webpack_public_path__ + "img/icon-cup-inactive.4ccce62e.png";